import { styled } from "styled-components";

export const CartBadge = styled.div`
  position: absolute;
  top: 20px;
  right: 90px;
  background-color: #ff5160;
  color: white;
  font-size: 12px;
  font-weight: bold;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
